import React, { useState } from "react";
import {
  Container,
  Box,
  Paper,
  TextField,
  Button,
  Typography,
  Alert,
} from "@mui/material";
import { useNavigate, Link } from "react-router-dom";
import { api } from "../context/AuthContext";

function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  async function handleSubmit(e) {
    e.preventDefault();
    setError("");
    setSuccess("");
    setLoading(true);

    try {
      const response = await api.post('/auth/forgot-password', { email });
      console.log("Forgot Password Response:", response.data);
      setSuccess(response.data?.message || "Password reset instructions have been sent to your email.");
    } catch (err) {
      console.error("Forgot Password Error:", err);
      setError(err.response?.data?.message || "Failed to send reset email. Please try again.");
    } finally {
      setLoading(false);
    }
  }

  return (
    <Container maxWidth="sm">
      <Box sx={{ mt: 8, mb: 4 }}>
        <Paper
          elevation={0}
          sx={{
            p: 4,
            borderRadius: "16px",
            border: "1px solid #E5E7EB",
            boxShadow: "0 10px 40px rgba(11, 16, 35, 0.08)",
            backgroundColor: "#fff",
          }}
        >
          <Typography
            variant="h4"
            align="center"
            gutterBottom
            sx={{ color: "#0A0F2C", fontWeight: 800 }}
          >
            Forgot Password
          </Typography>

          <Typography variant="body1" sx={{ mb: 3, textAlign: 'center', color: '#475569' }}>
            Enter your email to receive a reset link.
          </Typography>

          {error && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {error}
            </Alert>
          )}
          {success && (
            <Alert severity="success" sx={{ mb: 2 }}>
              {success}
            </Alert>
          )}

          <form onSubmit={handleSubmit} noValidate>
            <TextField
              fullWidth
              label="Email Address"
              type="email"
              variant="outlined"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              margin="normal"
              required
              disabled={!!success}
            />

            <Button
              type="submit"
              fullWidth
              variant="contained"
              size="large"
              sx={{ mt: 3, py: 1.5 }}
              disabled={loading || !!success}
            >
              {loading ? "Sending..." : "Send Reset Link"}
            </Button>
          </form>

          <Box sx={{ mt: 3, textAlign: "center" }}>
            <Typography variant="body2">
              Remember your password?{" "}
              <Link to="/login" style={{ color: "#1E3A8A", textDecoration: 'none', fontWeight: 'bold' }}>
                Click here to login
              </Link>
            </Typography>
          </Box>
        </Paper>
      </Box>
    </Container>
  );
}

export default ForgotPassword;
